import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../common/models/Visiable";
import { ClientsState } from "../models/ClientsState";

const setVisiableCommentForm = (state: ClientsState, actions: PayloadAction<Visiable>) => {
    state.visiableCommentForm = actions.payload.visiable;
}

export default setVisiableCommentForm;